export class CommonStrings{

  public static CONFIRM : string = "CONFIRM";

  public static BACK : string = "BACK";

  public static CANCEL : string = "CANCEL";

  public static TYPE_OF_TLD : string = "Type Of TLD";

  public static REGISTRY_OPERATOR : string = "Registry Operator";

  public static CC_TLD_MANAGER : string = "ccTLD Manager";

  public static ADMINISTRATIVE_CONTACT : string = "Administrative Contact";

  public static TECHNICAL_CONTACT : string = "Technical Contact";

  public static NAME_SERVERS : string = "Name Servers";

  public static TRUST_ANCHORS : string = "Delegation Signer Records";

  public static ADDITIONAL_INFORMATION : string = "Additional Information";


}
